import { render, staticRenderFns } from "./pie3d.vue?vue&type=template&id=e87259ca"
import script from "./pie3d.vue?vue&type=script&lang=js"
export * from "./pie3d.vue?vue&type=script&lang=js"
import style0 from "./pie3d.vue?vue&type=style&index=0&id=e87259ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports